import { render, staticRenderFns } from "./AnnualActionableCanteensTable.vue?vue&type=template&id=9906d964&scoped=true&"
import script from "./AnnualActionableCanteensTable.vue?vue&type=script&lang=js&"
export * from "./AnnualActionableCanteensTable.vue?vue&type=script&lang=js&"
import style0 from "./AnnualActionableCanteensTable.vue?vue&type=style&index=0&id=9906d964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9906d964",
  null
  
)

export default component.exports